import { jwtDecode } from "jwt-decode";

export const isTokenValid = (token) => {
  if (!token) return false;

  try {
    const decoded = jwtDecode(token);
    if (!decoded.exp) return true;
    return decoded.exp * 1000 > Date.now();
  } catch {
    return false;
  }
};

export const HOME_ROUTE = "/";

export const clearStoredSession = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("user");
};

export const markSessionExpired = () => {
  sessionStorage.setItem("sessionExpired", "1");
};

export const consumeSessionExpiredFlag = () => {
  const expired = sessionStorage.getItem("sessionExpired") === "1";
  if (expired) sessionStorage.removeItem("sessionExpired");
  return expired;
};

export const redirectAfterSessionExpired = () => {
  markSessionExpired();
  window.location.replace(HOME_ROUTE);
};
